import { render } from "./AddonCharts.vue?vue&type=template&id=532c775e&scoped=true"
import script from "./AddonCharts.vue?vue&type=script&lang=js"
export * from "./AddonCharts.vue?vue&type=script&lang=js"

import "./AddonCharts.vue?vue&type=style&index=0&id=532c775e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532c775e"]])

export default __exports__